import { render, staticRenderFns } from "./EditPriority.vue?vue&type=template&id=065e9326&scoped=true&"
import script from "./EditPriority.vue?vue&type=script&lang=js&"
export * from "./EditPriority.vue?vue&type=script&lang=js&"
import style0 from "./EditPriority.vue?vue&type=style&index=0&id=065e9326&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065e9326",
  null
  
)

export default component.exports